import { API } from '../../api';
import { Button, Col, Modal, Popconfirm, Row, Table, notification } from 'antd';
import { CloudUploadOutlined, DeleteOutlined } from '@ant-design/icons';
import { handleError } from '../../utils/util';
import { withRouter } from 'react-router-dom';
import FileUpload from './dataSourcesCreateSteps/fileUpload';
import PropTypes from 'prop-types';
import React from 'react';

class SampleDataTable extends React.Component {
  static propTypes = {
    fileId: PropTypes.string.isRequired,
    getSampleData: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    postNewFile: PropTypes.func.isRequired,
    sampleDataColumns: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        dataIndex: PropTypes.string.isRequired,
        key: PropTypes.string.isRequired,
        ellipsis: PropTypes.bool.isRequired,
      }),
    ).isRequired,
    sampleDataRows: PropTypes.arrayOf(PropTypes.object).isRequired, // eslint-disable-line react/forbid-prop-types
    setFile: PropTypes.func.isRequired,
    uploading: PropTypes.bool.isRequired,
  };

  state = {
    showModal: false,
  };

  /**
   * Toggles state of modal visibility.
   */
  toggleShowModal = () => {
    const { showModal } = this.state;
    this.setState({
      showModal: !showModal,
    });
  };

  /**
   * Sends request to delete data uploaded to S3.
   */
  removeData = async () => {
    const { fileId, getSampleData } = this.props;

    try {
      const deleteResponse = await API.delete(`/file/${fileId}/raw`);
      notification.success({
        description: `Removed Sample Data (${deleteResponse.status})`,
        duration: 2,
      });
      getSampleData();
    } catch (e) {
      handleError(e);
    }
  };

  render() {
    const { loading, postNewFile, sampleDataColumns, sampleDataRows, setFile, uploading } =
      this.props;
    const { showModal } = this.state;

    return (
      <>
        <Modal
          title="Update Data"
          visible={showModal}
          width={1000}
          onCancel={this.toggleShowModal}
          destroyOnClose
          footer={null}
        >
          <FileUpload
            postNewFile={postNewFile}
            setFile={setFile}
            includeMarginTop={false}
            loading={uploading}
            toggleShowModal={this.toggleShowModal}
          />
        </Modal>
        <Row justify="start" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col>
            <Button
              type="primary"
              icon={<CloudUploadOutlined />}
              onClick={() => this.toggleShowModal()}
            >
              Upload new data
            </Button>
          </Col>
          <Col>
            <Popconfirm title="Are you sure?" onConfirm={() => this.removeData()}>
              <Button icon={<DeleteOutlined />}>Remove Data</Button>
            </Popconfirm>
          </Col>
        </Row>
        <Table
          columns={sampleDataColumns}
          dataSource={sampleDataRows}
          size="small"
          scroll={{ x: 'max-content' }}
          loading={loading}
          style={{ marginTop: 14 }}
        />
      </>
    );
  }
}

export default withRouter(SampleDataTable);
